import { ContentMetadata } from '@/lib/model';
import { MediaBox } from '@/app/components/cards/common';
import { cn } from '@/lib/utils';

type Props = {
  mobileContentMetadata: ContentMetadata;
  desktopContentMetadata: ContentMetadata;
  containerClassName?: string;
  withDataTestId?: boolean;
  [k: string]: any;
};

export function PlatformMediaBox({
  mobileContentMetadata,
  desktopContentMetadata,
  containerClassName,
  withDataTestId,
  ...props
}: Props) {
  return (
    <>
      <div
        className={cn('block lg:hidden h-full', containerClassName)}
        {...(withDataTestId && {
          'data-testid': 'media:mobile',
        })}
      >
        <MediaBox
          contentMetadata={mobileContentMetadata}
          {...props}
          autoplay={false}
        />
      </div>
      <div
        className={cn('hidden lg:block h-full', containerClassName)}
        {...(withDataTestId && {
          'data-testid': 'media:desktop',
        })}
      >
        <MediaBox contentMetadata={desktopContentMetadata} {...props} />
      </div>
    </>
  );
}
